/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface SendToReaderDTO
 */
export interface SendToReaderDTOOptional {
  /**
   *
   * @type {string}
   * @memberof SendToReaderDTO
   */
  readerId?: string;
  /**
   *
   * @type {string}
   * @memberof SendToReaderDTO
   */
  paymentIntentId?: string;
}

export interface SendToReaderDTO extends SendToReaderDTOOptional {
  /**
   *
   * @type {string}
   * @memberof SendToReaderDTO
   */
  readerId: string;
  /**
   *
   * @type {string}
   * @memberof SendToReaderDTO
   */
  paymentIntentId: string;
}

export interface SendToReaderDTOTrackedI {
  /**
   *
   * @type {string}
   * @memberof SendToReaderDTO
   */
  readerId?: string;
  readerIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof SendToReaderDTO
   */
  paymentIntentId?: string;
  paymentIntentIdIsSet: boolean;
}

transformDatesMap.set("SendToReaderDTO", function (model: SendToReaderDTO) {});

export type SendToReaderDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  readerId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  paymentIntentId: PropertyMeta<MetaTypeBase<string>>;
}>;

export var SendToReaderDTOMeta: SendToReaderDTOMetaI =
  {} as SendToReaderDTOMetaI;
SendToReaderDTOMeta = typeMeta("SendToReaderDTO", {
  readerId: propertyMeta("readerId", false, true, false, MetaTypesBase.string),
  paymentIntentId: propertyMeta(
    "paymentIntentId",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = SendToReaderDTOMeta;

registerMeta(() => {});

export class SendToReaderDTOTracked implements SendToReaderDTOTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  readerId__I?: string = undefined;
  readerIdIsSet: boolean = false;
  set readerId(v: undefined | string) {
    if (v !== undefined) {
      this.readerId__I = v;
      this.readerIdIsSet = true;
    } else {
      this.readerId__I = v || undefined;
      this.readerIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get readerId() {
    return this.readerId__I;
  }
  paymentIntentId__I?: string = undefined;
  paymentIntentIdIsSet: boolean = false;
  set paymentIntentId(v: undefined | string) {
    if (v !== undefined) {
      this.paymentIntentId__I = v;
      this.paymentIntentIdIsSet = true;
    } else {
      this.paymentIntentId__I = v || undefined;
      this.paymentIntentIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get paymentIntentId() {
    return this.paymentIntentId__I;
  }
  constructor(config?: SendToReaderDTOOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: SendToReaderDTOOptional,
    options?: AssignOptions,
  ): SendToReaderDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.readerId && this.readerIdApplyFilter(optionsRequired.filter)) {
      this.readerId = config.readerId;
      if (optionsRequired.unassign) this.readerIdIsSet = false;
      else this.readerIdIsSet = true;
    }
    if (
      config.paymentIntentId &&
      this.paymentIntentIdApplyFilter(optionsRequired.filter)
    ) {
      this.paymentIntentId = config.paymentIntentId;
      if (optionsRequired.unassign) this.paymentIntentIdIsSet = false;
      else this.paymentIntentIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): SendToReaderDTOTrackedI {
    const cloned = {} as SendToReaderDTOTrackedI;
    if (
      this.readerIdIsSetDeep() &&
      this.readerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.readerIdIsSet = true;
      cloned.readerId = this.readerId;
    } else {
      //cloned.readerIdIsSet = false
    }
    if (
      this.paymentIntentIdIsSetDeep() &&
      this.paymentIntentIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.paymentIntentIdIsSet = true;
      cloned.paymentIntentId = this.paymentIntentId;
    } else {
      //cloned.paymentIntentIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): SendToReaderDTOTrackedI {
    if (!this.readerIdApplyFilter(filter)) this.readerIdIsSet = false;

    if (!this.paymentIntentIdApplyFilter(filter))
      this.paymentIntentIdIsSet = false;

    return this;
  }
  readerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      SendToReaderDTOMeta.readerId,
      SendToReaderDTOMeta,
      this.readerId,
      this,
    );
  }
  readerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.readerIdIsSet && this.readerIdApplyFilter(filter)) return true;

    return false;
  }
  paymentIntentIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      SendToReaderDTOMeta.paymentIntentId,
      SendToReaderDTOMeta,
      this.paymentIntentId,
      this,
    );
  }
  paymentIntentIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.paymentIntentIdIsSet && this.paymentIntentIdApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.readerIdIsSetDeep(filter)) return true;
    if (this.paymentIntentIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
